import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/Auth";
import UserDashboardSkeleton from "@/components/dashboard/UserDashboardSkeleton";

const PrivateRoute = () => {
  const { user, loading } = useAuth();

  if (loading) return <UserDashboardSkeleton />;

  return user ? <Outlet /> : <Navigate to="/auth/login" replace />;
};

export default PrivateRoute;
